// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__L-19M","inner":"Footer_inner__2Hu6d","nextIcon":"Footer_nextIcon__EQs1h","innerLeft":"Footer_innerLeft__2WwGU"};